export const advancedFilterActiveColor = '#136BFB'
export const advancedFilterDefaultColor = '#314959'
export const advancedFilterDefaultHoveredColor = '#314959AA'
export const advancedFilterDividerColor = '#31495940'
export const advancedFilterHRColor = '#CACACA'
export const listingDialogBreadCrumbContainerColor = '#343A3F'
export const listingDialogFilterContainerColor = '#EDEDED'
